import ConfirmAction from '@/components/confirm-action';
import EmptyState from '@/components/linear/empty-state';
import PageToolbar from '@/components/linear/page-toolbar';
import { deleteDraft, listDrafts, type IssueDraft } from '@/lib/drafts';
import { useEffect, useState } from 'react';

export default function Index() {
  const [drafts, setDrafts] = useState<IssueDraft[]>([]);

  useEffect(() => {
    const refresh = () => setDrafts(listDrafts());
    refresh();
    window.addEventListener('caprock:drafts', refresh);
    return () => window.removeEventListener('caprock:drafts', refresh);
  }, []);

  return (
    <div className="ln-page">
      <PageToolbar title="Drafts" showNew={false} />
      <div className="ln-page-scroll">
        {drafts.length === 0 ? (
          <EmptyState
            title="No drafts"
            description="Unsent issues are saved here when you close New issue with content."
          />
        ) : (
          drafts.map((draft) => (
            <div key={draft.id} className="ln-row">
              <span className="ln-row-title">{draft.title.trim() || 'Untitled'}</span>
              <span className="ln-row-meta">
                <ConfirmAction title="Delete draft?" onConfirm={() => deleteDraft(draft.id)}>
                  <button type="button" className="ln-toolbar-btn">
                    Delete
                  </button>
                </ConfirmAction>
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
